<template>
    <mm-select :options="options"
    v-bind="$attrs" :value="value" v-on="$listeners" />
</template>

<script>
export default {
	data(){
		const options = ['active','pending','paused'].map(v => {
			return { value: v, label: v.toUpperCase(),class:`status-${v}` };
		});
		return{
			options,
		}
	},
	props:['value'],
}
</script>

